/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";

//COMPONENTS GOOGLE
import {GoogleMap, useLoadScript, Marker, InfoWindow} from "@react-google-maps/api";

//COMPONENTS MUI
import { DataGrid } from '@mui/x-data-grid';
import {Grid, Button} from "@mui/material";

import EnviarDA from "../../components/RDAC/EnviarDA";
import "@reach/combobox/styles.css";
import Nav from "../../components/RDAC/Nav.js";
import { GRID_DEFAULT_LOCALE_TEXT, PAGINATION } from "../../constants/localeTextGrid";
import IdleTimeOutHandler from '../../components/RDAC/IdleTimeOutHandler';


const libraries = ["places"]

const mapContainerStyle = {
  width : "100%",
  height : "100%",
}

export default function ModificarCoordenades({json}) {

  const google = window.google;
  const numSerie = json.numSerie;
  const coordX = Number(json.longitud);
  const coordY = Number(json.latitud);
  const idOcurrencia = json.idOcurrencia;

  const[center, setCenter] = React.useState(null);
  //eslint-disable-next-line
  const[isActive,setIsActive]= React.useState(true);
  //eslint-disable-next-line
  const[isLogout,setLogout]= React.useState(false);

  const [markers, setMarkers] = React.useState([]);

  const [selected, setSelected] = React.useState(null);

  const [enviaDA, setEnviarDA] = React.useState(false);
  
  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
    language: 'ca',
  });

  const onMapClick = React.useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setCenter({lat : lat, lng : lng});
    setMarkers(current => [...current,{
      lat: lat,
      lng: lng,
      time: new Date(),
    },]);
  }, []);

  const removeMarker = React.useCallback((event) => {
    setMarkers((markers) => markers.filter((_,i) => i !== 0));
    setMarkers(current => [...current,{
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
      time: new Date(),
    },])
  })

  const mapRef = React.useRef();

  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
    if(!isNaN(coordX) && !isNaN(coordY)){
        setCenter({lat : coordY, lng : coordX});
        setMarkers(current => [...current,{
            lat: coordY,
            lng: coordX,
            time: new Date(),
          },]);
    }
    
  }, [coordX, coordY]);  

  const panTo = React.useCallback(({lat, lng}) => {
    mapRef.current.panTo({lat, lng});
    mapRef.current.setZoom(17);
    setCenter({lat : lat, lng : lng});
    setMarkers((markers) => markers.filter((_,i) => i !== 0));
    setMarkers(current => [...current,{
      lat: lat,
      lng: lng,
      time: new Date(),
    },])
  }, []);

  if (loadError){
    return "Error carregant el mapa";
  } 
  if (!isLoaded){
    return "Carregant Maps";
  }

  const columns = [
    { field: 'NUMERO_DE_SERIE', headerName: 'Número de sèrie', width: 150, renderCell: (params)=>{
      return(
        <div>{numSerie}</div>
      )
    } , disableClickEventBubbling: true, headerAlign: 'center', align: 'center' },
    { field: 'lng', headerName: 'Longitud', width: 250, disableClickEventBubbling: true, headerAlign: 'center', align: 'center' },
    { field: 'lat', headerName: 'Latitud', width: 250, disableClickEventBubbling: true, headerAlign: 'center', align: 'center'},
    { field: 'ENVIAR_MARCARDOR', headerName: '', width: 180, renderCell: (params) => {
      return (
          <strong>
          <Button onClick={() => {markers.length === 1 ? 
          setEnviarDA(true) : alert("Hi ha mes d'un marcador sel·leccionat. Sel·leccioni nomes un")
          }}
          > Enviar marcador
          </Button>
          {enviaDA === true && (
            (()=>{                
                setEnviarDA(false);
                return(
                  <EnviarDA
                    numSerie={numSerie}
                    idOc = {idOcurrencia}
                    coordY={params.row.lat}
                    coordX={params.row.lng}
                  />
                );
                })())}
        </strong>
      )
    }, disableClickEventBubbling: true,  headerAlign: 'center', align: 'center'},
  ];

  return (
      <div>
        <div className="App">
          <IdleTimeOutHandler 
          onActive={()=>{setIsActive(true)}}
          onIdle={()=>{setIsActive(false)}}
          onLogout={()=>{setLogout(true)}}
          />
        </div>
      <Grid className='Nav'>
        <Nav panTo={panTo}></Nav>
      </Grid>
      <Grid className='mapa1'>
        <GoogleMap
          mapContainerStyle={mapContainerStyle} 
          zoom={center ? 12 : 7.8}
          center={center ? center : {lat : 41.7,lng : 1.523}}
          onClick={markers.length === 0 ? onMapClick: removeMarker}
          onLoad={onMapLoad}
          options={{clickableIcons:false}}
        >
        {markers.map((marker,id) => (
          <Marker 
            key={marker.time.toISOString()} 
            position={{lat: marker.lat, lng: marker.lng}}
            onClick={() => {
              setSelected(marker);
            }}
            icon = {{
              url: "/DA-red.png",
              scaledSize: new google.maps.Size(30,30),
            }}
          />
        ))}
        {selected ? (
          <InfoWindow 
            position={{lat: selected.lat, lng: selected.lng}}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div>
              <p> Número de Sèrie : <strong>{numSerie}</strong></p>
              <p> Latitud : <strong>{ selected.lat }</strong> </p>
              <p> Longitud : <strong>{ selected.lng }</strong> </p>
              {/*<strong>
                <Button onClick={() => {markers.length === 1 ? 
                setEnviarDA(true) : alert("Hi ha mes d'un marcador sel·leccionat. Sel·leccioni nomes un")
                }}
                > Enviar marcador
                </Button>
                {enviaDA === true && 
                  (()=>{ 
                  console.log('hemos entrado');
                  setEnviarDA(false);
                  return(
                    <EnviarDA
                      numSerie={numSerie}
                      idOc={idOcurrencia}
                      coordX={selected.lng}
                      coordY={selected.lat}
                    />
                  );
                  })()}
                </strong>*/}
            </div>
          </InfoWindow>
        ) : null}
        </GoogleMap>
      </Grid>
      <Grid className="taulamapa1">
        <div>
          <h3 >{markers.length === 0 ? "Clicar el mapa per afegir marcadors" : ""}</h3>
          <div style={{height:'28vh', width:'100%'}}>
            <DataGrid 
              componentsProps={PAGINATION} 
              localeText={GRID_DEFAULT_LOCALE_TEXT} 
              columns={columns} 
              rows={markers.map((marker,id) => (marker))} 
              getRowId={(row) => row.lat}/>
          </div>
        </div>
      </Grid>
    </div>
  )
}